(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("FlyerImportController", FlyerImportController);

    /** @ngInject */
    function FlyerImportController($scope, Upload, toastr, $translate, FlyersService, $interval, $window, StoreService, $localStorage, systemConstants, Principal, HubFlyersService) {
        var vm = this;

        vm.file = null;
        vm.isLoading = false;
        vm.isUploading = false;
        vm.isImmoContext = $localStorage.defaultStore.immoContext;
        vm.isHubContext = $localStorage.defaultStore.hubContext;

        const HEADER_RETAIL = [
            "ean",
            "productReference",
            "name",
            "description",
            "gender",
            "brand",
            "category",
            "color",
            "size",
            "productPrice",
            "promotionalPrice",
            "qttPerPerson",
            "inventory",
            "height",
            "width",
            "length",
            "weight",
            "measureList",
            "images",
            "demoVideo",
            "tags"
        ];

        const HEADER_IMMO = [
            "realEstateName",
            "constructionCompany",
            "code",
            "incorporationRegister",
            "statusRealEstate",
            "deliveryDate",
            "description",
            "cep",
            "address",
            "number",
            "district",
            "city",
            "state",
            "latitude",
            "longitude",
            "unit",
            "type",
            "meters",
            "position",
            "bedroom",
            "parking",
            "bathroom",
            "unitPrice",
            "statusVariation",
            "demoVideo",
            "tags",
            "images"
        ]

        vm.flyerAttributes = HEADER_RETAIL;

        vm.currentStep = 1;

        vm.hubId = $localStorage.hub ? $localStorage.hub.id : $localStorage.defaultStore.hubId;

        vm.currentPage = 1;
        vm.numPerPage = 3;
        vm.flyerImportsList = [];


        const EXCEL_BASE_DATE = 25567; // Data base do Excel para o JavaScript (01/01/1900)
        const BRAZIL_TIMEZONE_OFFSET = 2; // Fuso horário do Brasil (GMT-3)
        const SECONDS_IN_A_DAY = 86400; // Quantidade de segundos em um dia
        const MILLISECONDS_IN_A_SECOND = 1000; // Quantidade de milissegundos em um segundo

        vm.$onInit = init;

        function init() {
            vm.descriptonStep1 = $translate.instant(getTranslateKey(vm.isImmoContext, "flyers.import.steps.step1.description2"));

            listImportFlyersStatus();

            if (vm.isImmoContext) {
                vm.flyerAttributes = angular.copy(HEADER_IMMO);
                if (!vm.isHubContext) {
                    const idx = vm.flyerAttributes.indexOf("constructionCompany");
                    if (idx !== -1) {
                        vm.flyerAttributes.splice(idx, 1);
                    }
                }
            } else {
                vm.flyerAttributes = angular.copy(HEADER_RETAIL);
            }
        }

        vm.changePage = function(page) {
            if (page) {
                vm.currentPage = page;
            }
            listImportFlyersStatus();
        };

        function listImportFlyersStatus() {
            vm.isLoadingImports = true;

            var apiPage = vm.currentPage - 1;

            var requestPromise;

            if (vm.isHubContext) {
                requestPromise = HubFlyersService.listImportHubFlyersStatus(apiPage, vm.numPerPage);
            } else {
                requestPromise = FlyersService.listImportFlyersStatus(apiPage, vm.numPerPage);
            }

            requestPromise
                .then(function (response) {
                    vm.flyerImportsList = response.content;
                    vm.totalImports = response.totalElements;

                    if (vm.totalImports === 0) {
                        vm.startRegistry = 0;
                        vm.endRegistry = 0;
                    } else {
                        vm.startRegistry = (apiPage * vm.numPerPage) + 1;
                        vm.endRegistry = vm.startRegistry + vm.flyerImportsList.length - 1;
                    }
                })
                .catch(function (error) {
                    console.error('Error loading imports:', error);
                    vm.flyerImportsList = [];
                    vm.totalImports = 0;
                })
                .finally(function () {
                    vm.isLoadingImports = false;
                });
        }

        // Função para formatar datas do Excel
        /**
         * Converte uma data do Excel para o formato de data do JavaScript.
         * @param {number} excelDate - A data no formato do Excel.
         * @returns {Date} - A data convertida para o formato do JavaScript.
         */
        function formatExcelDate(excelDate) {
            var date = new Date(
                (excelDate - (EXCEL_BASE_DATE + BRAZIL_TIMEZONE_OFFSET)) *
                    SECONDS_IN_A_DAY *
                    MILLISECONDS_IN_A_SECOND
            );
            date.setHours(date.getHours() + 3);
            return moment(date).format(
                $translate.instant("flyers.import.dateFormat")
            );
        }

        vm.gotoStep = function (step) {
            if (shouldPreventStepChange(step)) {
                return;
            }
            if (step === 3 && !validateRequiredFields()) {
                return;
            }
            if (step === 3) {
                getPreview();
            }
            vm.currentStep = step;
        };

        function shouldPreventStepChange(step) {
            return ((step === 2 || step === 3) && !vm.file) || vm.isUploading;
        }

        function validateRequiredFields() {
            if (!vm.isImmoContext) {
                return requiredFieldsHaveBeenSelected();
            } else {
                return requiredFieldsHaveBeenSelectedImmo();
            }
        }

        vm.loadFile = function (file, errFiles) {
            vm.file = file;
            vm.errFiles = errFiles && errFiles[0];
            vm.isLoading = true;
            vm.importResult = null;
            vm.errorSummary = null;

            if (vm.errFiles) {
                vm.isLoading = false;
                if (errFiles[0].$error == "pattern") {
                    toastr.error($translate.instant("flyers.import.error.invalidType"));
                    return;
                }
            }

            if (file) {
                vm.currentStep = 2;

                var fileReader = new FileReader();
                fileReader.onload = function() {
                    this.arrayBuffer = fileReader.result;
                    var data = new Uint8Array(this.arrayBuffer);
                    var arr = new Array();
                    for (var i = 0; i != data.length; ++i)
                        arr[i] = String.fromCharCode(data[i]);
                    var bstr = arr.join("");
                    var workbook = XLSX.read(bstr, {
                        type: "binary", sheetRows: 4
                    });
                    var first_sheet_name = workbook.SheetNames[0];
                    var worksheet = workbook.Sheets[first_sheet_name];

                    vm.headers = getHeaderRow(worksheet);

                    autoMapColumns();

                    var sheetsList = workbook.SheetNames;
                    vm.sheetData = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheetsList[0]],
                        {
                            header: 1,
                            defval: "",
                            blankrows: true
                        }
                    );

                    vm.isLoading = false;

                    $scope.$apply();
                };
                fileReader.readAsArrayBuffer(file);
            } else {
                vm.isLoading = false;
            }
        };

        function getHeaderRow(sheet) {
            var headers = [];
            var range = XLSX.utils.decode_range(sheet["!ref"]);
            var C,
                R = range.s.r; /* start in the first row */
            /* walk every column in the range */
            for (C = range.s.c; C <= range.e.c; ++C) {
                var cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]; /* find the cell in the first row */
                var hdr = "UNKNOWN " + C; // <-- replace with your desired default
                if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

                headers.push({ column: numToSSColumn(C + 1), key: hdr, value: "NULL" });
            }
            return headers;
        }

        vm.uploadSpreadsheet = function () {
            if (vm.isHubContext) {
                vm.uploadHubFile();
            } else {
                vm.uploadFile();
            }
        }

        vm.uploadHubFile = function () {
            if (vm.file) {
                vm.isUploading = true;

                vm.file.upload = Upload.upload({
                    url: 'flyer/api/hub-flyer/hub/' + vm.hubId + '/import-flyers-from-table?headers=' + getHeadersStringList(),
                    data: {
                        file: vm.file
                    }
                });

                vm.file.upload.then(function (response) {
                    if (response.data) {
                        var interval = $interval(function () {
                            HubFlyersService.flyersImportStatus(response.data.id)
                                .then(function (response) {
                                    var data = JSON.parse(response.data)
                                    if (data.status === 'FINISHED') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        toastr.success($translate.instant('flyers.import.statusSuccessfulDescription'));
                                        vm.currentStep = 1;
                                        vm.file = null;
                                        listImportFlyersStatus();
                                    } else if (data.status === 'PENDING' || data.status === 'IN_PROGRESS') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        toastr.success($translate.instant(vm.getTranslateKey('flyers.import.successfullyImport')));
                                        vm.currentStep = 1;
                                        vm.file = null;
                                        listImportFlyersStatus();
                                    } else if (data.status === 'CANCELLED_REPEATED_IMPORT') { 
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        if (data.headersUpdated) {
                                            toastr.success($translate.instant(vm.getTranslateKey('flyers.import.successfullyImport')));
                                        } else {
                                            toastr.warning($translate.instant('flyers.import.cancelledSameFile'));
                                        }
                                        vm.currentStep = 1;
                                        vm.file = null;
                                        listImportFlyersStatus();
                                    } else if (data.status === 'VALIDATION_FAILED') {
                                        $interval.cancel(interval);
                                        vm.importResult = data;
                                        if (data.duplicatedProductReferences && data.duplicatedProductReferences.length) {
                                            vm.errorSummary = null;
                                            errorOnFileUploadOrSaveImport('flyers.import.hubDuplicateReferencesTitle');
                                        } else {
                                            errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                            getErrorSummary();
                                        }
                                        listImportFlyersStatus();
                                    }
                                }, function (data) {
                                    $interval.cancel(interval);
                                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                })
                                .catch(function (err) {
                                    $interval.cancel(interval);
                                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                });
                        }, 5000);
                        listImportFlyersStatus();
                    } else {
                        errorOnFileUploadOrSaveImport('flyers.import.error.errorOnUploadFile');
                    }

                }, function (response) {
                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnUploadFile');
                });
            }
        }

        function errorOnFileUploadOrSaveImport(error) {
            toastr.error($translate.instant(error));
            vm.isUploading = false;
        }

        vm.uploadFile = function () {
            if (vm.file) {
                vm.isUploading = true;

                vm.file.upload = Upload.upload({
                    url: 'flyer/api/flyer/import-flyers-from-table?headers=' + getHeadersStringList(),
                    data: {
                        file: vm.file
                    }
                });

                vm.file.upload.then(function (response) {
                    if (response.data) {
                        // vm.file = null;

                        var interval = $interval(function () {
                            FlyersService.flyersImportStatus(response.data.id)
                                .then(function (response) {
                                    var data = JSON.parse(response.data)
                                    if (data.status === 'FINISHED') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        toastr.success($translate.instant('flyers.import.statusSuccessfulDescription'));
                                        vm.currentStep = 1;
                                        vm.file = null;
                                        listImportFlyersStatus();
                                    } else if (data.status === 'PENDING' || data.status === 'IN_PROGRESS') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        toastr.success($translate.instant('flyers.import.successfullyImport'));
                                        vm.currentStep = 1;
                                        vm.file = null;
                                        listImportFlyersStatus();
                                    } else if (data.status === 'CANCELLED_REPEATED_IMPORT') {
                                        $interval.cancel(interval);
                                        vm.isUploading = false;
                                        if (data.headersUpdated) {
                                            toastr.success($translate.instant('flyers.import.successfullyImport'));
                                        } else {
                                            toastr.warning($translate.instant('flyers.import.cancelledSameFile'));
                                        }
                                        vm.currentStep = 1;
                                        vm.file = null;
                                        listImportFlyersStatus();
                                    } else if (data.status === 'VALIDATION_FAILED') {
                                        $interval.cancel(interval);
                                        var errorMessage = data.maxSizeError ? 'flyers.import.error.errorMaxSizeImport' : 'flyers.import.error.errorOnSaveImport';
                                        errorOnFileUploadOrSaveImport(errorMessage);
                                        vm.importResult = data;

                                        getErrorSummary();
                                        listImportFlyersStatus();
                                    }
                                }, function (data) {
                                    $interval.cancel(interval);
                                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                })
                                .catch(function (err) {
                                    $interval.cancel(interval);
                                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                                });
                        }, 5000);
                        listImportFlyersStatus();
                    } else {
                        errorOnFileUploadOrSaveImport('flyers.import.error.errorOnUploadFile');
                    }

                }, function (response) {
                    errorOnFileUploadOrSaveImport('flyers.import.error.errorOnUploadFile');
                });
            }
        }

        vm.cancel = function () {
            vm.file = null;
        }

        function errorOnFileUploadOrSaveImport(error) {
            toastr.error($translate.instant(error));
            vm.isUploading = false;
        }

        function getHeadersList() {
            return vm.headers.map(function (item) {
                return item.value;
            });
        }

        function getHeadersStringList() {
            return getHeadersList().join();
        }

        vm.getXlsxResult = function () {
            if( !vm.importResult.details && vm.importResult.maxSizeError) {
                errorOnFileUploadOrSaveImport('flyers.import.error.errorMaxSizeImport');
                return;
            }

            var fileExt = '.xlsx';
            var fileName = vm.importResult.id + fileExt;
            var header = vm.flyerAttributes.concat(["errors"]);

            var details = JSON.parse(JSON.stringify(vm.importResult.details));

            if (!details) {
                errorOnFileUploadOrSaveImport('flyers.import.error.errorOnSaveImport');
                return;
            }

            if (vm.isImmoContext) {
                details = getXlsxResultDetails(HEADER_IMMO, details);
            } else {
                details = getXlsxResultDetails(HEADER_RETAIL, details);
            }

            details.forEach(function (product) {
                var errors = product.errors.map(function (error) {
                    return $translate.instant(getTranslateKey(vm.isImmoContext,'flyers.import.error.' + error));
                }).join(' | ');
                product.errors = errors;
            });

            var workbook = XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(details, { header: header });

            var range = XLSX.utils.decode_range(worksheet['!ref']);

            // translate header
            for (var C = range.s.c; C <= range.e.c; ++C) {
                var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
                if (!worksheet[address]) continue;
                worksheet[address].v = $translate.instant('flyers.import.column.' + worksheet[address].v);
            }

            var wscols = [];
            for (var i = 0; i < header.length; i++) {  // columns length added
                wscols.push({ wch: 15 })
            }
            wscols[wscols.length - 1] = { wch: 80 };
            worksheet["!cols"] = wscols;

            XLSX.utils.book_append_sheet(workbook, worksheet, 'tab1');
            XLSX.writeFile(workbook, fileName, { compression: true });
        }

        function getXlsxResultDetails(headers, details) {
            return details.map(function (product) {
                var newProduct = {};
                headers.forEach(function (header) {
                    if (header === 'tags' && Array.isArray(product.tags)) {
                        newProduct.tags = product.tags.join('; ');
                    } else {
                        newProduct[header] = product[header];
                    }
                });
                newProduct.errors = product.errors;
                if (product.images) {
                    newProduct.images = product.images.join(';');
                } else {
                    product.images = ""
                }
                return newProduct;
            });
        }

        vm.changeHeaderValue = function(header) {
            vm.errorSummary = null;
            if (header.value === '') {
                header.value = 'NULL';
            } else {
                vm.headers.forEach(function (item) {
                    if (header.key !== item.key && header.value === item.value) {
                        header.value = 'NULL';
                        toastr.warning($translate.instant('flyers.import.error.repeatedColumn'));
                    }
                });
            }
        }

        function autoMapColumns() {
            if (!vm.headers || !vm.flyerAttributes) {
                return;
            }

            const expectedHeaders = vm.isImmoContext ? HEADER_IMMO : HEADER_RETAIL;

            vm.headers.forEach(function (header) {
                const match = expectedHeaders.find(function(attr) {
                    return $translate.instant('flyers.import.column.' + attr).toLowerCase() === header.key.toLowerCase();
                });
                if (match) {
                    header.value = match;
                }
            });
        }


        function numToSSColumn(num) {
            var s = '', t;

            while (num > 0) {
                t = (num - 1) % 26;
                s = String.fromCharCode(65 + t) + s;
                num = (num - t) / 26 | 0;
            }
            return s || undefined;
        }

        function getSelectedHeaders() {
            return vm.headers.filter(function (item) {
                return item.value !== 'NULL';
            });
        }

        function getPreview() {
            if (!vm.sheetData) {
                return;
            }
            var data = [];
            var headers = vm.headers.map(function (item) {
                return item.value !== 'NULL' ? $translate.instant('flyers.import.column.' + item.value) : item.value;
            });

            for (var i = 1; i < vm.sheetData.length; i++) {
                var result = [];
                for (var j = 0; j < headers.length; j++) {
                    var value = vm.sheetData[i][j];
                    if (headers[j] !== 'NULL') {
                        if (headers[j] === $translate.instant('flyers.import.column.deliveryDate')) {
                            value = formatExcelDate(value);
                        }

                        result.push(value);
                    }
                }
                data.push(result);
            }
            var headersPreview = headers.filter(function (header) {
                return header !== 'NULL';
            })

            vm.importPreview = {
                headers: headersPreview,
                data: data
            }
        }

       function getErrorSummary() {
            vm.errorSummary = [];

            if (vm.importResult && vm.importResult.details) {
                vm.importResult.details.forEach(function (product) {
                    product.errors.forEach(function (error) {
                        if (!vm.errorSummary.includes(getTranslateKey(vm.isImmoContext,error))) {
                            vm.errorSummary.push(vm.getTranslateKey(error))
                        }
                    });
                });
            }
        }

        vm.getTranslateKey = function(baseKey) {
            return getTranslateKey(vm.isImmoContext, baseKey)
        };

        function requiredFieldsHaveBeenSelected() {
            var eanOrProductReference = false;
            var otherField = false;
            getSelectedHeaders().forEach(function (header) {
                if (header.value === "ean" || header.value === "productReference") {
                    eanOrProductReference = true;
                } else if (header.value !== "size") {
                    otherField = true;
                }
            });

            if (!eanOrProductReference) {
                toastr.warning($translate.instant('flyers.import.error.notAllowedNullableProductReferenceOrEan'));
            } else if (!otherField) {
                toastr.warning($translate.instant('flyers.import.error.noColumn'));
            }

            return eanOrProductReference && otherField;
        }

        function requiredFieldsHaveBeenSelectedImmo() {
            var requiredFields = [
                "realEstateName",
                "code",
                "unit",
                "type",
                "meters",
                "unitPrice",
                "statusVariation"
            ];
            var selectedHeaders = getSelectedHeaders().map(function (header) {
                return header.value;
            });

            var missingFields = requiredFields.filter(function (field) {
                return !selectedHeaders.includes(field);
            });

            if (missingFields.length > 0) {
                var translatedFields = missingFields.map(function (field) {
                    return $translate.instant('flyers.import.column.' + field);
                });
                toastr.warning(
                    $translate.instant(
                        "flyers.import.error.missingRequiredFields"
                    ) +
                        ": " +
                        translatedFields.join(", ")
                );
                return false;
            }

            return true;
        }


        vm.getDownloadLinkToTemplate = function () {
            if (vm.isImmoContext && vm.isHubContext) {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/template-import-ventures_4.0.xlsx';
            } else if (vm.isImmoContext) {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/template-import-ventures-hub-immo_4.0.xlsx';
            } else {
                return 'https://showkase-prod.s3.sa-east-1.amazonaws.com/hub/system-images/template-import-products_3.0.xlsx';
            }
        };
    }
})();
